import { ResourceOptions } from 'react-admin';
import { MdAccountBalanceWallet } from 'react-icons/md';
import { Resources } from '../../resource';

export { default as list } from './List';

export const name = Resources.xbitRelayDepositWallets;
export { XBIT_RELAY_DEPOSIT_WALLETS_PERMISSION_RESOURCE } from './constants';
export const icon = MdAccountBalanceWallet;
export const options: ResourceOptions = {
  label: 'module.xbitRelayDepositWallets.title',
};
